import { z } from 'zod';

import { BorrowerId, WorkoutPlanId } from '../BrandedIds';
import { BaseLoanIdSideEffect } from './BaseLoanIdSideEffect';

export const GeneratePaymentDeferralOfferLetterSideEffectContext = BaseLoanIdSideEffect.extend({
  workoutPlanId: WorkoutPlanId,
  borrowerIds: z.array(BorrowerId),
});

export const GeneratePaymentDeferralOfferLetterSideEffect = GeneratePaymentDeferralOfferLetterSideEffectContext.extend({
  type: z.literal('generatePaymentDeferralOfferLetter'),
});
export type GeneratePaymentDeferralOfferLetterSideEffect = z.infer<typeof GeneratePaymentDeferralOfferLetterSideEffect>;
